/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScheduledTask
 */
export interface ScheduledTask {
    /**
     * 
     * @type {number}
     * @memberof ScheduledTask
     */
    taskId: number;
    /**
     * 
     * @type {number}
     * @memberof ScheduledTask
     */
    minDurationSeconds?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ScheduledTask
     */
    maxDurationSeconds?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ScheduledTask
     */
    durationSeconds?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ScheduledTask
     */
    totalDurationSeconds?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ScheduledTask
     */
    numberOfTasks?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ScheduledTask
     */
    userIds?: Array<string> | null;
}

/**
 * Check if a given object implements the ScheduledTask interface.
 */
export function instanceOfScheduledTask(value: object): value is ScheduledTask {
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    return true;
}

export function ScheduledTaskFromJSON(json: any): ScheduledTask {
    return ScheduledTaskFromJSONTyped(json, false);
}

export function ScheduledTaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduledTask {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['task_id'],
        'minDurationSeconds': json['min_duration_seconds'] == null ? undefined : json['min_duration_seconds'],
        'maxDurationSeconds': json['max_duration_seconds'] == null ? undefined : json['max_duration_seconds'],
        'durationSeconds': json['duration_seconds'] == null ? undefined : json['duration_seconds'],
        'totalDurationSeconds': json['total_duration_seconds'] == null ? undefined : json['total_duration_seconds'],
        'numberOfTasks': json['number_of_tasks'] == null ? undefined : json['number_of_tasks'],
        'userIds': json['user_ids'] == null ? undefined : json['user_ids'],
    };
}

export function ScheduledTaskToJSON(json: any): ScheduledTask {
    return ScheduledTaskToJSONTyped(json, false);
}

export function ScheduledTaskToJSONTyped(value?: ScheduledTask | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task_id': value['taskId'],
        'min_duration_seconds': value['minDurationSeconds'],
        'max_duration_seconds': value['maxDurationSeconds'],
        'duration_seconds': value['durationSeconds'],
        'total_duration_seconds': value['totalDurationSeconds'],
        'number_of_tasks': value['numberOfTasks'],
        'user_ids': value['userIds'],
    };
}

